<template>

    <input type="range" min="0" max="1" step="0.1" class="form-control" v-model="handler" @input="change">

</template>

<script>

export default {
  props: ['config', 'name', 'value'],
  data(){
      return {
          handler:'',
      }
  },
  mounted(){
      this.handler = this.value;
  },
  methods:{
    change(){
        this.$emit('change',this.handler);
    },
  }

}
</script>
